import * as React from "react";
const SvgDrinkAlcoholic = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20.958 3a.75.75 0 0 0-1.413-.502L19.362 3H13.75a.75.75 0 0 0-.75.75v5.5c0 1.323.19 2.738.858 3.844.6.993 1.548 1.675 2.892 1.857V20.5h-2a.75.75 0 0 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-2V14.95c1.344-.182 2.292-.864 2.892-1.857.668-1.106.858-2.52.858-3.844v-5.5a.75.75 0 0 0-.75-.75h-.292ZM20.5 8h-1.36l1.273-3.5h.087V8Zm-1.906 1.5h1.903c-.024 1.124-.213 2.114-.639 2.818-.42.694-1.106 1.182-2.358 1.182s-1.939-.488-2.358-1.182c-.426-.704-.615-1.694-.64-2.818h2.495l-.452 1.244a.75.75 0 1 0 1.41.512l.639-1.756ZM17.544 8H14.5V4.5h4.317L17.543 8ZM2.185 13.256A.75.75 0 0 1 2.75 13h8.5a.75.75 0 0 1 .743.849l-1 7.5a.75.75 0 0 1-.744.65h-6.5a.75.75 0 0 1-.743-.65l-1-7.5a.75.75 0 0 1 .18-.593ZM4.14 18.5l.267 2h5.187l.267-2H8.747l-.366.634a1 1 0 0 1-1.366.366l-1.299-.75a.996.996 0 0 1-.288-.25H4.139Zm5.92-1.5.334-2.5H3.606L3.94 17h1.633l.528-.915a1 1 0 0 1 1.366-.366l1.3.75a.996.996 0 0 1 .441.53h.852Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDrinkAlcoholic;
